/**
 * Mobile Payment Amount Selector
 * Re-exports the unified PaymentAmountSection with mobile-friendly prop names
 * 
 * @deprecated Import PaymentAmountSection from '@/components/residents/payments/shared' instead
 */

import React from 'react';
import { TextInput } from '@/components/common/text';
import { PaymentAmountSection } from '@/components/residents/payments/shared/PaymentAmountSection';

interface PaymentAmountSelectorProps {
  balanceDue: number;
  selectedOption: 'balance' | 'other';
  customAmount: string;
  onSelectBalance: () => void;
  onSelectOther: () => void;
  onCustomAmountChange: (amount: string) => void;
  onInfoPress?: () => void;
  residentName?: string;
  disabled?: boolean;
  error?: string;
  minimumAmount?: number;
  inputRef?: React.RefObject<TextInput | null>;
}

/**
 * Payment amount selector with radio buttons for Balance due and Other amount
 * Matches Figma design for Make a Payment flow
 */
export const PaymentAmountSelector: React.FC<PaymentAmountSelectorProps> = ({
  balanceDue,
  selectedOption,
  customAmount,
  onSelectBalance,
  onSelectOther,
  onCustomAmountChange,
  onInfoPress,
  residentName,
  disabled = false,
  error,
  minimumAmount,
  inputRef,
}) => {
  return (
    <PaymentAmountSection
      variant="mobile"
      balanceDue={balanceDue}
      isCustomAmount={selectedOption === 'other'}
      customAmount={customAmount}
      onSelectBalanceDue={onSelectBalance}
      onSelectCustomAmount={onSelectOther}
      onCustomAmountChange={onCustomAmountChange}
      onInfoPress={onInfoPress}
      displayName={residentName}
      disabled={disabled}
      validationError={error}
      minimumAmount={minimumAmount}
      inputRef={inputRef}
    />
  );
};
